import React from 'react';
import ContentContainer from '../../components/LayoutComponents/ContentContainer';
import SmsStatementForm from '../../components/CbsComponents/Sms/SmsStatementForm';

const SmsStatement: React.FC = () => {
  const breadcrumbs = [
    {
      title: 'sms-statement.page-title',
      href: `/sms/statement`,
    },
  ];
  return (
    <ContentContainer
      helmetTitle="sms-statement.helmet-title"
      pageTitle="sms.page-title"
      breadcrumbs={breadcrumbs}
    >
      <SmsStatementForm />
    </ContentContainer>
  );
};

export default SmsStatement;
